const fullMarkdown = `* 夕水(eveningwater),
* 目前在成都工作
-----
技能
-----
* 熟悉前端开发
* 高效的自学能力
-----
工作项目
-----
1. [个人网站](http://eveningwater.com/)
2. [大师有空](http://api.soulside.cn/masterv3_web_formal/public/wap/wapmaster/dist/#/?id=1)
3. [阳光助学系统](http://help.qianjiang.kunyueyun.com/#/)
4. [园区服务系统](http://pss.kunyueyun.com/#/login)
5. [企业应用系统](http://pes.kunyueyun.com/#/login)
6. [商家服务系统](http://bss.kunyueyun.com/#/login)
7. [园区官网(旧版)](http://park.kunyueyun.com/#/login)
8. [园区官网(新版)](http://www.kunyueyun.com/)
9. [捧场客后台管理系统](http://www.pengchangke.com.cn/admin/#/)
10. [领梵后台](https://h5.ledfin.cn)
11. 相关APP页面若干
12. 领梵小程序
13. [17素材](http://www.17sucai.com/pins/26618.html)
-----
其它爱好
-----
* 诗词(主要发表在以下网站):
* [中国诗歌网](http://www.zgshige.com/c/2016-11-07/2029387.shtml)
* [诗词在线](http://www.chinapoesy.com/gongxianglist894225B7-3462-42F6-8B0D-118B36FF31D8.html)
-----
* 完结小说(已上线)
* [高手来都市](http://www.zhujiange.com/book/57433/index.html),虽然写的比较烂,哈哈哈哈哈!
-----
> 如果你喜欢这个效果的话,欢迎下载[源码](https://github.com/eveningwater/vue-resume)研究。`
export default fullMarkdown;


// WEBPACK FOOTER //
// ./src/my.js